import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

import { Shell } from '@app/shell/shell.service';
import { SharedServiceCreateComponent } from './shared-service-create.component';

const routes: Routes = [
  // { path: '', redirectTo: '/case-request', pathMatch: 'full' },
  Shell.childRoutes([
    { path: 'case-request', component: SharedServiceCreateComponent, data: { title: marker('shared service') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class SharedServiceCreateRouting {}
